import { type FC, useState } from "react";
import * as styles from "./styles.css";

type Props = {
  shopNames: string[];
};

const SHOP_NAMES_TRUNCATE_THRESHOLD = 9;

export const ShopNames: FC<Props> = ({ shopNames }) => {
  const [isTruncated, setIsTruncated] = useState(shopNames.length > SHOP_NAMES_TRUNCATE_THRESHOLD);

  if (shopNames.length === 0) {
    return null;
  }

  if (!isTruncated) {
    return (
      <>
        <td colSpan={6} className={styles.shopName}>
          <p>{shopNames.join(" / ")}</p>
        </td>
      </>
    );
  }

  return (
    <>
      <td colSpan={6} className={styles.shopName}>
        <p className={styles.shopNamePartial}>
          {shopNames.slice(0, 9).join(" / ")}
          <button
            type="button"
            onClick={() => setIsTruncated(false)}
            className={styles.shopNameButton}
          >
            もっと見る
          </button>
        </p>
      </td>
    </>
  );
};
